import { supabase } from '@/lib/supabase';

export const insertPerformanceService = async (performanceData: any) => {
    try {
        const { data: existingPerf } = await supabase
            .from('Performances')
            .select('id')
            .eq('shop_id', performanceData.shop_id)
            .eq('hairdresser_id', performanceData.hairdresser_id)
            .eq('name', performanceData.name)
            .single();

        if (existingPerf) {
            const { data: updated, error } = await supabase
                .from('Performances')
                .update({ ...performanceData, is_active: true })
                .eq('id', existingPerf.id)
                .select()
                .single();

            if (error) throw error;
            return { success: true, data: updated, isUpdate: true };
        } else {
            const { data, error } = await supabase
                .from('Performances')
                .insert([{ ...performanceData, is_active: true }])
                .select()
                .single();

            if (error) throw error;
            return { success: true, data, isUpdate: false };
        }
    } catch (error: any) {
        return { success: false, error: error.message };
    }
};

export const deletePerformanceService = async (id: number, hasBookings: boolean) => {
    try {
        if (hasBookings) {
            const { data, error } = await supabase
                .from('Performances')
                .update({ is_active: false })
                .eq('id', id)
                .select()
                .single();

            if (error) throw error;
            return { success: true, isSoftDelete: true, data };
        } else {
            const { error } = await supabase.from('Performances').delete().eq('id', id);
            if (error) throw error;
            return { success: true, isSoftDelete: false };
        }
    } catch (error: any) {
        return { success: false, error: error.message };
    }
};
